import Row from './Row'
import Col from './Col'
import Button from './Button'
import ButtonGroup from './ButtonGroup'
import Icon from './Icon'
import Input from './Input'
import Radio from './Radio'
import RadioGroup from './RadioGroup'
import Checkbox from './Checkbox'
import iSwitch from './iSwitch'
import Select from './Select'
import Option from './Option'
import Slider from './Slider'
import DatePicker from './DatePicker'
import TimePicker from './TimePicker'
import InputNumber from './InputNumber'
import Rate from './Rate'
import Form from './Form'
import FormItem from './FormItem'

var obj = {
    Row,
    Col,
    Button,
    ButtonGroup,
    Icon,
    Input,
    Radio,
    RadioGroup,
    Checkbox,
    iSwitch,
    Select,
    Option,
    Slider,
    DatePicker,
    TimePicker,
    InputNumber,
    Rate,
    Form,
    FormItem
}

export default obj



// WEBPACK FOOTER //
// ./src/components/template/iView-UI/index.js